import * as Yup from "yup";
import { toast } from "react-toastify";
import { IoChevronDownOutline } from "react-icons/io5";
import { GrView } from "react-icons/gr";
import { useEffect, useState } from "react";

import { SearchIcon } from "../../assets/Icons";
import { ModalContainer } from "../../components/PageComponents";
import ProfileImage from "../../../src/assets/images/ProfileImage.svg";
import { LabelInput } from "../../components/Reusable/Layout";
import { FloatingLabelSelect } from "../../components/Reusable/Layout";
import { Button } from "../../components/Reusable/Button";
import { CloseIcon } from "../../icons/promotions";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { createAdmin, updateUser } from "../../features/auth/store/userSlice";
import { RootState } from "../../redux/store";
import { CreateAdminData } from "../../features/auth/store/types/user-types";
import {
  UserTableProps,
  AdminSearchFilterProps,
  UserDetailModalProps,
} from "./types";

export const ADMIN_ROLE_OPTIONS = [
  { value: "super_admin", label: "Super Administrator" },
  { value: "admin", label: "Administrator" },
  { value: "finance_admin", label: "Finance Admin" },
  { value: "accountant", label: "Accountant" },
  { value: "support_admin", label: "Customer Service Admin" },
  { value: "customer_service", label: "Customer Service" },
  { value: "developer", label: "Developer " },
];

export const ADMIN_ROLE_VALUES = ADMIN_ROLE_OPTIONS.map((role) => role.value);

export const UsersTable = ({
  users,
  onUserClick,
  loading,
  currentPage,
  totalPages,
  onPageChange,
  total,
  perPage,
}: UserTableProps) => {
  const goToNextPage = () => {
    if (onPageChange && currentPage && totalPages) {
      if (currentPage < totalPages) {
        onPageChange(currentPage + 1);
      }
    }
  };

  const goToPreviousPage = () => {
    if (onPageChange && currentPage) {
      if (currentPage > 1) {
        onPageChange(currentPage - 1);
      }
    }
  };

  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto">
        <table className="w-full border border-[#FFFFFF1A] rounded-2xl overflow-hidden">
          <thead>
            <tr className="bg-gray-100 dark:bg-[#FFFFFF1A] text-gray-600 dark:text-white uppercase text-xs bp:text-sm leading-normal h-[50px]">
              <th className="px-6 text-left ">
                <div className="flex items-center gap-1">
                  <input type="checkbox" className="mr-2" />
                  <p>Email Address</p>
                </div>
              </th>
              <th className="px-6 text-left ">Phone Number</th>
              <th className="px-6 text-left ">First Name</th>
              <th className="px-6 text-left ">Last Name</th>
              <th className="px-6 text-left">Role</th>
              <th className="px-6 text-left">Country</th>
              <th className="px-6 text-left">View</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 dark:text-white text-xs bp:text-sm">
            {loading ? (
              <tr className="border-b border-gray-200 h-[50px]">
                <td colSpan={7} className="px-6 text-center">
                  Loading...
                </td>
              </tr>
            ) : users.length > 0 ? (
              users.map((user) => (
                <tr key={user.id} className="border-b border-gray-200 h-[50px]">
                  <td className="px-6 py-4 align-middle">
                    <div className="flex items-center gap-3">
                      <span>{user.avatar}</span>
                      <span>{user.email}</span>
                    </div>
                  </td>
                  <td className="px-6 ">{user.username}</td>
                  <td className="px-6 ">{user.firstname}</td>
                  <td className="px-6 ">{user.lastname}</td>
                  <td className="px-6">{user.role}</td>
                  <td className="px-6">{user.country}</td>
                  <td onClick={() => onUserClick(user)} className="px-6">
                    <GrView />
                  </td>
                </tr>
              ))
            ) : (
              <tr className="border-b border-gray-200 h-[50px]">
                <td colSpan={5} className="px-6 text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center border-t border-[#FFFFFF1A]">
        <button
          className={`border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A] ${
            currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={goToPreviousPage}
          disabled={currentPage === 1 || loading}
        >
          Previous
        </button>
        <span className="text-gray-600 dark:text-white text-xs bp:text-sm">
          Page {currentPage} of {totalPages || 1}
        </span>
        <button
          className={`border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A] ${
            currentPage === totalPages || totalPages === 0 || loading
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
          onClick={goToNextPage}
          disabled={currentPage === totalPages || totalPages === 0 || loading}
        >
          Next
        </button>
      </div>
    </div>
  );
};
export const AdminSearchFilter: React.FC<AdminSearchFilterProps> = ({
  onFilterChange,
  filters,
  filterOptions,
  countries,
  loading,
  onClick,
}) => {
  // const [isOpen, setIsOpen] = useState(false);
  // const [selectedRole, setSelectedRole] = useState("Role");

  // const roles = ["Customer Service", "Admin", "Super Admin", "Accountant"];

  // const toggleDropdown = () => {
  //   setIsOpen(!isOpen);
  // };

  // const selectRole = (role: any) => {
  //   setSelectedRole(role);
  //   setIsOpen(false);
  // };
  return (
    <div className="flex flex-col bp:flex-row bp:items-center bp:justify-between mb-4 gap-2">
      <div className="relative">
        <input
          type="text"
          onChange={(e) => onFilterChange("search", e.target.value)}
          placeholder="Search for a user..."
          className="border p-2 pl-10 rounded-3xl w-[260px] h-[40px] bp:h-[48px] bp:w-[500px] dark:text-white dark:bg-[#FFFFFF1A] bg-[#F4F4F5] dark:border-[#FFFFFF1A]"
        />
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
          <SearchIcon />
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-2">
        <div className="flex items-center justify-between gap-2">
          <select
            name="country"
            onChange={(e) => onFilterChange("country", e.target.value)}
            className="border p-2 w-[260px] h-[40px] md:w-[100px] rounded-3xl 
               bg-[#F4F4F5] text-black border-gray-300
               dark:bg-[#27272A] dark:text-white dark:border-[#3F3F46]"
          >
            {" "}
            <IoChevronDownOutline />
            <option value="" className="dark:text-white">
              Country
            </option>
            {countries.map((country) => (
              <option
                key={country.id}
                value={country.name}
                className="dark:bg-[#FFFFFF1A] dark:border-[#FFFFFF1A] dark:text-white"
              >
                {country.name}
              </option>
            ))}
          </select>
        </div>
        <div className="relative">
          <select
            name="role"
            onChange={(e) => onFilterChange("role", e.target.value)}
            className="border p-2 bg-[#F4F4F5] w-[260px] h-[40px] md:w-[100px] rounded-3xl dark:bg-[#27272A] dark:text-white dark:border-[#3F3F46]"
          >
            {" "}
            <IoChevronDownOutline />
            <option value="">Role</option>
            {filterOptions?.role_options?.map((role: string) => (
              <option key={role} value={role}>
                {role}
              </option>
            ))}
          </select>
        </div>

        <select
          name="status"
          onChange={(e) => onFilterChange("status", e.target.value)}
          className="border p-2 bg-[#F4F4F5] w-[260px] h-[40px] md:w-[100px] rounded-3xl  dark:bg-[#27272A] dark:text-white dark:border-[#3F3F46]"
        >
          {" "}
          {filterOptions?.status_options?.map((status: string) => (
            <option key={status} value={status}>
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </option>
          ))}
        </select>

        <Button
          onClick={onClick}
          bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
          textColor="text-white"
          borderRadius="rounded-lg"
          className="w-full h-10 ml-6"
        >
          Create admin
        </Button>
      </div>
    </div>
  );
};

export const UserDetailModal = ({
  user,
  showTabs = true,
  tabItems = ["Personal", "Role"],
  onClose,
}: UserDetailModalProps) => {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state: RootState) => state.users);
  const [toggle, setToggle] = useState<string>(tabItems[0]);
  const [selectedRole, setSelectedRole] = useState<string>(user?.role || "");

  useEffect(() => {
    setSelectedRole(user?.role || "");
  }, [user]);

  const handleSaveRole = async () => {
    const userId = user?.user_id || user?.id;
    if (!userId) {
      toast.error("Unable to update role for this user");
      return;
    }

    try {
      await dispatch(
        updateUser({
          user_id: Number(userId),
          data: { role: selectedRole },
        }),
      ).unwrap();
      toast.success("Role updated successfully!");
      onClose();
    } catch (error) {
      toast.error("Failed to update role");
    }
  };

  // Create a function to render different content based on toggle state
  const renderContent = () => {
    switch (toggle) {
      case "Personal Information":
        return (
          <div className="mt-4 space-y-4">
            <div className="grid gap-4">
              <div>
                <LabelInput
                  type="text"
                  value={user?.country || ""}
                  placeholder="Country"
                  name="country"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <LabelInput
                  type="text"
                  value={user?.firstname || ""}
                  placeholder="First Name"
                  name="firstName"
                />
              </div>
              <div>
                <LabelInput
                  type="text"
                  value={user?.lastname || ""}
                  placeholder="Last Name"
                  name="lastName"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <LabelInput
                  type="email"
                  value={user?.email || ""}
                  placeholder="Email Address"
                  name="email"
                />
              </div>
              <div>
                <LabelInput
                  type="tel"
                  value={user?.phone_number || ""}
                  placeholder="Phone Number"
                  name="phone"
                />
              </div>
            </div>
            <div>
              <LabelInput
                type="text"
                value={user?.birthdate || ""}
                placeholder="Birth Date"
                name="birthDate"
              />
            </div>
            <div className="flex justify-end">
              <button className="border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A]">
                Save changes
              </button>
            </div>
          </div>
        );
      case "Role":
        return (
          <div className="mt-8 space-y-4">
            <FloatingLabelSelect
              value={selectedRole}
              placeholder="Select Role"
              name="role"
              onChange={(e) => setSelectedRole(e.target.value)}
              options={ADMIN_ROLE_OPTIONS}
            />
            <div className="flex justify-end">
              <button
                onClick={handleSaveRole}
                disabled={loading || !selectedRole}
                className="border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A] disabled:opacity-50"
              >
                {loading ? "Saving..." : "Save role"}
              </button>
            </div>
          </div>
        );
    }
  };

  return (
    <ModalContainer
      title="User Details"
      closeIcon={
        <button onClick={onClose}>
          <CloseIcon />
        </button>
      }
    >
      <div className="bg-BG-light dark:bg-BG-dark flex items-center p-4 rounded-md mb-4">
        <div className="mr-4">
          <img
            src={user?.profile_image || ProfileImage}
            alt="Profile"
            className="w-[160px] h-[160px] rounded-full"
          />
        </div>

        <div>
          <p className="font-bold text-[40px] dark:text-white dark:bg-[#FFFFFF1A] dark:border-[#FFFFFF1A] rounded-md p-4">
            {user
              ? `${user.firstname || ""} ${user.lastname || ""}`.trim() || "N/A"
              : "Loading..."}
          </p>
          <div className="flex items-center gap-4 dark:text-white">
            <p className="text-sm">{user?.username || "N/A"}</p>
            <span className="">|</span>
            <p className="text-sm">
              Joining date:{" "}
              {user?.created_at
                ? new Date(user.created_at).toLocaleDateString()
                : "N/A"}
            </p>
          </div>
          <div className="bg-amber-50 text-amber-500 rounded-lg w-32">
            <p className="p-2 text-base">{user?.status || "Unknown"}</p>
          </div>
        </div>
      </div>

      {showTabs && tabItems.length > 0 && (
        <div className="rounded-lg p-[6px] bg-[#F4F4F5] dark:bg-BG-dark w-[300px] h-[42px] flex">
          {tabItems.map((item, index) => (
            <button
              key={index}
              className={`flex-1 py-[6px] px-[6px] bp:px-[10px] text-xs place-content-center ${
                toggle === item
                  ? "inter-xs-semibold-dark rounded-lg font-inter dark:text-white bg-[#FCFCFD] dark:bg-[#FFFFFF1A]"
                  : "inter-xs-medium-toggleBG-dark dark:text-main-dark"
              }`}
              onClick={() => setToggle(item)}
            >
              {item}
            </button>
          ))}
        </div>
      )}

      {/* Render content based on the selected tab */}
      {renderContent()}
    </ModalContainer>
  );
};

export const CreateAdminModal = ({
  onClose,
  isOpen,
  handleOverlayClick,
  handleModalClick,
}: {
  onClose: () => void;
  isOpen: boolean;
  handleOverlayClick: (e: React.MouseEvent) => void;
  handleModalClick: (e: React.MouseEvent) => void;
}) => {
  const adminSchema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    firstname: Yup.string().required("First name is required"),
    lastname: Yup.string().required("Last name is required"),
    othername: Yup.string().required("Other name is required"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
    phone_number: Yup.string()
      .min(10, "Phone number must be at least 10 characters")
      .max(15, "Phone number must not exceed 15 characters")
      .required("Phone number is required"),
    language: Yup.string().required("Language is required"),
    country: Yup.string().required("Country is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .required("Password is required"),
    role: Yup.string().required("Role is required"),
  });
  const dispatch = useAppDispatch();
  const { loading, error } = useAppSelector((state: RootState) => state.users);

  const [formData, setFormData] = useState<CreateAdminData>({
    username: "",
    firstname: "",
    lastname: "",
    othername: "",
    role: "admin", // Default to admin
    phone_number: "",
    email: "",
    language: "",
    country: "",
    password: "",
  });

  // Form validation errors
  const validateForm = async (): Promise<boolean> => {
    try {
      await adminSchema.validate(formData, { abortEarly: false });
      setErrors({});
      return true;
    } catch (validationError: any) {
      const newErrors: Partial<CreateAdminData> = {};
      if (validationError.inner) {
        validationError.inner.forEach((err: any) => {
          if (err.path)
            newErrors[err.path as keyof CreateAdminData] = err.message;
        });
      }
      setErrors(newErrors);
      return false;
    }
  };
  const [errors, setErrors] = useState<Partial<CreateAdminData>>({});

  // Handle input changes
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (errors[name as keyof CreateAdminData]) {
      setErrors((prev) => ({
        ...prev,
        [name]: undefined,
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = await validateForm();
    if (!isValid) return;

    try {
      const result = await dispatch(createAdmin(formData));

      if (createAdmin.fulfilled.match(result)) {
        // Reset form
        setFormData({
          username: "",
          firstname: "",
          lastname: "",
          othername: "",
          role: "admin",
          phone_number: "",
          email: "",
          language: "",
          country: "",
          password: "",
        });
        setErrors({});

        // Close modal
        onClose();

        // You might want to show a success message here
        toast("Admin created successfully!");
      }
    } catch (error) {
      console.error("Failed to create admin:", error);
    }
  };

  if (!isOpen) return null;
  return (
    <ModalContainer
      title="Create Admin"
      closeIcon={
        <button onClick={onClose}>
          <CloseIcon />
        </button>
      }
    >
      <form onSubmit={handleSubmit} className="mt-4 space-y-4">
        {/* Display API error if any */}
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
            {error}
          </div>
        )}
        <div className="grid grid-cols-1 gap-4">
          <div>
            <LabelInput
              type="text"
              value={formData.username}
              placeholder="Username"
              name="username"
              onChange={handleInputChange}
            />
            {errors.username && (
              <p className="text-red-500 text-xs mt-1">{errors.username}</p>
            )}
          </div>
          <div>
            <LabelInput
              type="text"
              value={formData.firstname}
              placeholder="First Name"
              name="firstname"
              onChange={handleInputChange}
            />
            {errors.firstname && (
              <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>
            )}
          </div>
          <div>
            <LabelInput
              type="text"
              value={formData.lastname}
              placeholder="Last Name"
              name="lastname"
              onChange={handleInputChange}
            />
            {errors.lastname && (
              <p className="text-red-500 text-xs mt-1">{errors.lastname}</p>
            )}
          </div>
        </div>

        <div>
          <LabelInput
            type="text"
            value={formData.othername}
            placeholder="Other Name"
            name="othername"
            onChange={handleInputChange}
          />
          {errors.othername && (
            <p className="text-red-500 text-xs mt-1">{errors.othername}</p>
          )}
        </div>

        <div className="grid grid-cols-1 gap-4">
          <div>
            <LabelInput
              type="email"
              value={formData.email}
              placeholder="Email Address"
              name="email"
              onChange={handleInputChange}
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email}</p>
            )}
          </div>
          <div>
            <LabelInput
              type="tel"
              value={formData.phone_number}
              placeholder="Phone Number"
              name="phone_number"
              onChange={handleInputChange}
            />
            {errors.phone_number && (
              <p className="text-red-500 text-xs mt-1">{errors.phone_number}</p>
            )}
          </div>
        </div>
        <div>
          <LabelInput
            type="tel"
            value={formData.language}
            placeholder="Language"
            name="language"
            onChange={handleInputChange}
          />
          {errors.language && (
            <p className="text-red-500 text-xs mt-1">{errors.language}</p>
          )}
        </div>
        <div>
          <LabelInput
            type="tel"
            value={formData.country}
            placeholder="Country"
            name="country"
            onChange={handleInputChange}
          />
          {errors.country && (
            <p className="text-red-500 text-xs mt-1">{errors.country}</p>
          )}
        </div>
        <div>
          <LabelInput
            type="password"
            value={formData.password}
            placeholder="Password"
            name="password"
            onChange={handleInputChange}
          />
          {errors.password && (
            <p className="text-red-500 text-xs mt-1">{errors.password}</p>
          )}
        </div>

        <div>
          <FloatingLabelSelect
            value={formData.role}
            placeholder="Select Role"
            name="role"
            onChange={handleInputChange}
            options={ADMIN_ROLE_OPTIONS}
          />
          {errors.role && (
            <p className="text-red-500 text-xs mt-1">{errors.role}</p>
          )}
        </div>

        <div className="flex justify-end">
          <Button
            type="submit"
            disabled={loading}
            bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
            textColor="text-white"
            borderRadius="rounded-lg"
            className="w-[156px] h-10 ml-6"
          >
            {loading ? "Creating..." : "Create Account"}
          </Button>
        </div>
      </form>
    </ModalContainer>
  );
};
